module.exports = __webpack_public_path__ + "img/25.e6a63c05.svg";